import type { IWorkPeriod } from "@/interfaces/api/work-period.interface.ts"
import { BaseRepository } from "@/repositories/base-repository.ts"

export class WorkPeriodRepository extends BaseRepository<IWorkPeriod> {
  resourcePath = "administration/work-periods"
}
